import React from "react";
import moment from "moment";
import { useFormik } from "formik";
import { Row, Col } from "reactstrap";

import { TextInput } from "../../components/Input";
import FormikErrorText from "../../components/FormikErrorText/FormikErrorText";
import { LABLES, NAMES, PLACEHOLDERS } from "./WebFormFieldsNames";
import validationSchema from "./FormValidations";
import SingleDatePicker from "../../components/Input/SingleDatePicker";

const DirectorDetailsForm = ({ directorData }) => {
    let {
        DIRECTOR_NAME,
        DIRECTOR_FULL_ADDRESS,
        DIRECTOR_TITLE,
        AS_OF_DATE,
        CONTACT_NUMBER,
        FAX,
        EMAIL,
        WEBSITE,
        APPOINTMENT_CALENDER_LINK
    } = LABLES;

    const defaultAsOfDate = directorData.dob
        ? moment(directorData.dob, "DD MMM, YYYY").toDate()
        : new Date();
    const formik = useFormik({
        initialValues: {
            [NAMES[DIRECTOR_NAME]]: directorData.name || "",
            [NAMES[DIRECTOR_FULL_ADDRESS]]: directorData.address || "",
            [NAMES[DIRECTOR_TITLE]]: directorData.title || "",
            [NAMES[AS_OF_DATE]]: defaultAsOfDate,
            [NAMES[CONTACT_NUMBER]]: directorData.contact || "",
            [NAMES[FAX]]: directorData.fax || "",
            [NAMES[EMAIL]]: directorData.email || "",
            [NAMES[WEBSITE]]: directorData.website || "",
            [NAMES[APPOINTMENT_CALENDER_LINK]]: directorData.calendarLink || ""
        },
        enableReinitialize: true,
        validationSchema: validationSchema,
        onSubmit: (values) => {}
    });

    return (
        <>
            <Row className="mt-4">
                <Col md="4">
                    <TextInput
                        placeholder={PLACEHOLDERS[DIRECTOR_NAME]}
                        label={DIRECTOR_NAME}
                        name={NAMES[DIRECTOR_NAME]}
                        type={NAMES[DIRECTOR_NAME]}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values[NAMES[DIRECTOR_NAME]]}
                        labelClass="custom-label mb-0"
                        className="hide-default-icon text-input"
                        autoFocus
                    />

                    <FormikErrorText
                        formikInstance={formik}
                        fieldName={NAMES[DIRECTOR_NAME]}
                        className="error"
                    />
                </Col>
                <Col md="4">
                    <TextInput
                        placeholder={PLACEHOLDERS[DIRECTOR_FULL_ADDRESS]}
                        label={DIRECTOR_FULL_ADDRESS}
                        name={NAMES[DIRECTOR_FULL_ADDRESS]}
                        type={NAMES[DIRECTOR_FULL_ADDRESS]}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values[NAMES[DIRECTOR_FULL_ADDRESS]]}
                        labelClass="custom-label mb-0"
                        className="hide-default-icon text-input"
                        autoFocus
                    />

                    <FormikErrorText
                        formikInstance={formik}
                        fieldName={NAMES[DIRECTOR_FULL_ADDRESS]}
                        className="error"
                    />
                </Col>
                <Col md="4">
                    <TextInput
                        placeholder={PLACEHOLDERS[DIRECTOR_TITLE]}
                        label={DIRECTOR_TITLE}
                        name={NAMES[DIRECTOR_TITLE]}
                        type={NAMES[DIRECTOR_TITLE]}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values[NAMES[DIRECTOR_TITLE]]}
                        labelClass="custom-label mb-0"
                        className="hide-default-icon text-input"
                        autoFocus
                    />

                    <FormikErrorText
                        formikInstance={formik}
                        fieldName={NAMES[DIRECTOR_TITLE]}
                        className="error"
                    />
                </Col>
            </Row>
            <Row className="mt-4">
                <Col md="4">
                    <SingleDatePicker
                        labelClass="custom-label mb-0"
                        label={AS_OF_DATE}
                        selectedDate={formik.values[NAMES[AS_OF_DATE]] || defaultAsOfDate}
                        handleChangeDate={(date) => formik.setFieldValue(NAMES[AS_OF_DATE], date)}
                        icon="bx bx-calendar"
                    />
                    <FormikErrorText
                        formikInstance={formik}
                        fieldName={NAMES[AS_OF_DATE]}
                        className="error"
                    />
                </Col>

                <Col md="4">
                    <TextInput
                        placeholder={PLACEHOLDERS[CONTACT_NUMBER]}
                        label={CONTACT_NUMBER}
                        name={NAMES[CONTACT_NUMBER]}
                        type={NAMES[CONTACT_NUMBER]}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values[NAMES[CONTACT_NUMBER]]}
                        labelClass="custom-label mb-0"
                        className="hide-default-icon text-input"
                        autoFocus
                    />

                    <FormikErrorText
                        formikInstance={formik}
                        fieldName={NAMES[CONTACT_NUMBER]}
                        className="error"
                    />
                </Col>
                <Col md="4">
                    <TextInput
                        placeholder={PLACEHOLDERS[FAX]}
                        label={FAX}
                        name={NAMES[FAX]}
                        type={NAMES[FAX]}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values[NAMES[FAX]]}
                        labelClass="custom-label mb-0"
                        className="hide-default-icon text-input"
                        autoFocus
                    />

                    <FormikErrorText
                        formikInstance={formik}
                        fieldName={NAMES[FAX]}
                        className="error"
                    />
                </Col>
            </Row>
            <Row className="mt-4">
                <Col md="4">
                    <TextInput
                        placeholder={PLACEHOLDERS[EMAIL]}
                        label={EMAIL}
                        name={NAMES[EMAIL]}
                        type={NAMES[EMAIL]}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values[NAMES[EMAIL]]}
                        labelClass="custom-label mb-0"
                        className="hide-default-icon text-input"
                        autoFocus
                    />

                    <FormikErrorText
                        formikInstance={formik}
                        fieldName={NAMES[EMAIL]}
                        className="error"
                    />
                </Col>
                <Col md="4">
                    <TextInput
                        placeholder={PLACEHOLDERS[WEBSITE]}
                        label={WEBSITE}
                        name={NAMES[WEBSITE]}
                        type={NAMES[WEBSITE]}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values[NAMES[WEBSITE]]}
                        labelClass="custom-label mb-0"
                        className="hide-default-icon text-input"
                        autoFocus
                    />

                    <FormikErrorText
                        formikInstance={formik}
                        fieldName={NAMES[WEBSITE]}
                        className="error"
                    />
                </Col>
                <Col md="4">
                    <TextInput
                        placeholder={PLACEHOLDERS[APPOINTMENT_CALENDER_LINK]}
                        label={APPOINTMENT_CALENDER_LINK}
                        name={NAMES[APPOINTMENT_CALENDER_LINK]}
                        type={NAMES[APPOINTMENT_CALENDER_LINK]}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values[NAMES[APPOINTMENT_CALENDER_LINK]]}
                        labelClass="custom-label mb-0"
                        className="hide-default-icon text-input"
                        autoFocus
                    />

                    <FormikErrorText
                        formikInstance={formik}
                        fieldName={NAMES[APPOINTMENT_CALENDER_LINK]}
                        className="error"
                    />
                </Col>
            </Row>
        </>
    );
};

export default DirectorDetailsForm;
